"use client";

import React from "react";

import type { UserAccount } from "@/features/users/user.type";
import { AppHeader } from "./app-header";
import { AppSidebar } from "./app-sidebar";

interface AuthenticatedAppShellProps {
  children: React.ReactNode;
  user: UserAccount | null | undefined;
  isSidebarOpen: boolean;
  isSidebarCollapsed: boolean;
  isShopRoute: boolean;
  onMenuToggle: () => void;
  onSidebarClose: () => void;
  onSidebarCollapseToggle: () => void;
  onSignOut: () => void;
}

export function AuthenticatedAppShell({
  children,
  user,
  isSidebarOpen,
  isSidebarCollapsed,
  isShopRoute,
  onMenuToggle,
  onSidebarClose,
  onSidebarCollapseToggle,
  onSignOut,
}: AuthenticatedAppShellProps) {
  return (
    <div className="flex h-screen overflow-hidden bg-background">
      {isSidebarOpen && (
        <div
          className="fixed inset-0 z-40 bg-black/50 backdrop-blur-sm md:hidden"
          onClick={onSidebarClose}
        />
      )}

      <AppSidebar
        user={user}
        isOpen={isSidebarOpen}
        isCollapsed={isSidebarCollapsed}
        isShopRoute={isShopRoute}
        onCollapseToggle={onSidebarCollapseToggle}
        onNavigate={onSidebarClose}
        onSignOut={onSignOut}
      />

      <div className="flex min-w-0 flex-1 flex-col">
        <AppHeader
          onMenuToggle={onMenuToggle}
          isSidebarOpen={isSidebarOpen}
        />

        <main className="min-h-0 flex-1 overflow-y-auto">
          <div className="p-3">{children}</div>
        </main>
      </div>
    </div>
  );
}
